import styles from './index.module.scss';
import { utility } from '@phi/components';
import { defineComponent, h, nextTick, ref, watch } from 'vue';

export const PopUnder = defineComponent({
    props: {
        hidden: {
            required: true,
            type: Boolean,
        },
    },

    setup(props, { slots }) {
        const completely_hidden = ref(props.hidden);
        const shown = ref(false);

        watch(
            () => props.hidden,
            (value) => {
                if (value) {
                    shown.value = false;
                    setTimeout(() => completely_hidden.value = props.hidden, 250);
                } else {
                    completely_hidden.value = false;
                    nextTick(() => requestAnimationFrame(() => shown.value = !props.hidden));
                }
            },
            {
                immediate: true,
            }
        );

        return () => h('div', {
            class: {
                [styles.popunder]: true,
                [styles.shown]: shown.value,
                [utility.hidden]: completely_hidden.value,
                [utility.do_interact]: true,
                [utility.do_interact_with_children]: true,
                [utility.absolute]: true,
                [utility.entire_screen]: true,
                [utility.z_maximum]: true,
            },
        }, slots.default && slots.default());
    },
});
